/*
 *  Instagram
 *    Scripts for the Instagram Feed section. Creates a slick slide for
 *    smaller devices
 *
 *  Version:
 *    1.0.0 - 2019/04/16
 */

import { CarouselSection } from '../carousel/CarouselSection';
import { register } from '../ShopifySection';
import * as ResponsiveSizes from '../../../settings/Responsive';


export const CONTAINER_SELECTOR = '[data-instagram]';
export const FEED_SELECTOR = '[data-instagram-feed]'; //FourSixty

export const FEED_ID = 'data-feed-id';

export class Instagram extends CarouselSection {
  constructor(container) {
    super(container);


    this.feed = container.find(FEED_SELECTOR);
    if(this.feed.length) {
      this.checkPosition();
      $(window).on('scroll', () => this.checkPosition());
    }
  }

  checkPosition() {
    if(this.loaded) return;
    let winHeight = $(window).height();
    let elTop = this.container.offset().top;
    let scrollTop = $(window).scrollTop();

    let trigger = elTop - winHeight * 1.5;
    if(scrollTop > trigger) {
      this.loadFoursixty();
      $(window).on('resize orientationchange', () => this.loadFoursixty());
      this.loaded = true;
    }
  }

  loadFoursixty() {
    let width = $(window).width();

    // if(this.type == 'slider-desktop' && width >= ResponsiveSizes.large) return;
    // if(this.type == 'slider-desktop' && width < ResponsiveSizes.large) return;

    let id = this.feed.attr(FEED_ID);

    if(!id) return;
    let script = document.createElement('script');
    script.setAttribute(FEED_ID, id);

    this.type = 'slider-desktop';
    script.src = "//foursixty.com/media/scripts/fs.slider.v2.5.js";
    script.setAttribute("data-theme", "slider_v2_5");
    // script.setAttribute("data-page-size", "5");
    script.setAttribute("data-cell-size", "20%");

    this.feed.html(script);
  }
}

register(CONTAINER_SELECTOR, Instagram);
